import React, { useState, useEffect } from "react";
import PlayerJohn from "../assets/img/playerJohn.png";
import TrojansLogo from "../assets/img/1200px-USC_Trojans_logo.svg.png";

import "../assets/css/coachProfileDarkTimeline.scss";
import "../../../../../../assets/css/stylesheet.scss";
import "../../../../../../assets/css/owl.carousel.min.css";

import "../../../../../../assets/css/stylesheet.scss";


import OwlCarousel from "react-owl-carousel";
import "owl.carousel/dist/owl.carousel.js";
import "owl.carousel/dist/owl.carousel.min.js";
import Timeline from "./Timeline";
import FollowMetricsCarousel from "./FollowMetricsCarousel";
import { previewProfileStart } from "../../../../../../redux/auth/signup/previewProfile"
import { previewProfileQuery } from "./profileViewQuery"
import { connect } from "react-redux"

const options = {
  loop: true,
  margin: 10,
  nav: true,
  dots: false,
  // autoplay:true,
  autoplayTimeout: 2000,
  autoplayHoverPause: true,
  items: 1,
}
const FollowDarkProfile = (props) => {
  const [expand, setExpand] = useState(false);
  const handleCollapseExpand = () => {
    setExpand(!expand);
  };
  useEffect(async () => {
    props.previewProfileStart({
      query: previewProfileQuery,
      variables: {
        obj: {
          id: parseInt(localStorage.getItem('validUserId'))
        },
      },
    })
  }, []);

  return (
    <div>
      <div className="coachProfileDarkTimelineSection coachProfileWrap">
        <div className="topSection">
          <div className="container">
            <div className="coachProfileFlexBox">
              <div className="carousel">
                {/* <div className="profileCarousel owl-carousel owl-theme"></div> */}

                <OwlCarousel
                  className="profileCarousel owl-carousel owl-theme"
                  {...options}
                >
                  <div className="item">
                    <img src={PlayerJohn} alt="" />
                  </div>
                  <div className="item">
                    <img src={PlayerJohn} alt="" />
                  </div>
                  <div className="item">
                    <img src={PlayerJohn} alt="" />
                  </div>
                </OwlCarousel>
              </div>
              {props.userDetails.data ?
                props.userDetails.data.map(item =>
                  <>
                  <div className="coachInfo">
                    <h2 className="pName">
                      <span>{item.athletefirstname + " " + item.athletelastname}</span>
                      <span className="icon">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="26.418"
                          height="26.403"
                          viewBox="0 0 26.418 26.403"
                        >
                          <defs>
                            <style></style>
                          </defs>
                          <path
                            className="a"
                            d="M-4229.021-6663.778a1.151,1.151,0,0,1-.986-.543,1.174,1.174,0,0,0-.993-.543,1.174,1.174,0,0,0-.993.543,1.151,1.151,0,0,1-.986.543,1.169,1.169,0,0,1-1.152-.9v-.005a1.179,1.179,0,0,0-1.149-.9,1.16,1.16,0,0,0-.728.256,1.169,1.169,0,0,1-.729.259,1.2,1.2,0,0,1-.883-.392,1.158,1.158,0,0,1-.3-.9l0-.013a1.161,1.161,0,0,0-.3-.9,1.184,1.184,0,0,0-.87-.387,1.181,1.181,0,0,0-.395.068h-.005a1.189,1.189,0,0,1-.4.07,1.175,1.175,0,0,1-.984-.544,1.155,1.155,0,0,1-.084-1.116l.01-.021a1.174,1.174,0,0,0-.088-1.121,1.175,1.175,0,0,0-.989-.538h-.033a1.163,1.163,0,0,1-1.08-.708,1.164,1.164,0,0,1,.219-1.274l.019-.019a1.171,1.171,0,0,0,.28-1.09,1.176,1.176,0,0,0-.769-.831l-.02,0a1.164,1.164,0,0,1-.8-1.02,1.164,1.164,0,0,1,.621-1.138l.02-.01a1.174,1.174,0,0,0,.621-.943,1.172,1.172,0,0,0-.456-1.031l-.02-.017a1.161,1.161,0,0,1-.425-1.223,1.164,1.164,0,0,1,.957-.875l.017,0a1.174,1.174,0,0,0,.894-.688,1.172,1.172,0,0,0-.1-1.125l-.013-.021a1.159,1.159,0,0,1-.058-1.2,1.173,1.173,0,0,1,1.03-.625,1.229,1.229,0,0,1,.215.019h.008a1.234,1.234,0,0,0,.21.019,1.166,1.166,0,0,0,.928-.459,1.169,1.169,0,0,0,.207-1.017l0-.017a1.148,1.148,0,0,1,.2-1.012,1.2,1.2,0,0,1,.938-.467,1.169,1.169,0,0,1,.572.151,1.16,1.16,0,0,0,.571.15,1.186,1.186,0,0,0,1.177-1.092v-.01a1.176,1.176,0,0,1,1.184-1.092,1.158,1.158,0,0,1,.866.39,1.159,1.159,0,0,0,.871.39,1.18,1.18,0,0,0,1.086-.715,1.162,1.162,0,0,1,1.084-.717,1.162,1.162,0,0,1,1.084.715,1.18,1.18,0,0,0,1.086.717,1.159,1.159,0,0,0,.871-.39,1.158,1.158,0,0,1,.866-.39,1.176,1.176,0,0,1,1.184,1.092v.01a1.186,1.186,0,0,0,1.177,1.092,1.16,1.16,0,0,0,.569-.148,1.164,1.164,0,0,1,.574-.153,1.2,1.2,0,0,1,.938.467,1.148,1.148,0,0,1,.2,1.012l-.005.017a1.169,1.169,0,0,0,.207,1.017,1.166,1.166,0,0,0,.928.459,1.234,1.234,0,0,0,.21-.019h.008a1.229,1.229,0,0,1,.215-.019,1.172,1.172,0,0,1,1.029.625,1.158,1.158,0,0,1-.057,1.2l-.013.021a1.172,1.172,0,0,0-.1,1.125,1.174,1.174,0,0,0,.894.688l.017,0a1.164,1.164,0,0,1,.958.875,1.161,1.161,0,0,1-.425,1.222l-.021.017a1.173,1.173,0,0,0-.456,1.032,1.174,1.174,0,0,0,.621.943l.021.01a1.164,1.164,0,0,1,.621,1.138,1.164,1.164,0,0,1-.8,1.02l-.02,0a1.179,1.179,0,0,0-.769.831,1.171,1.171,0,0,0,.283,1.09l.016.019a1.164,1.164,0,0,1,.218,1.273,1.163,1.163,0,0,1-1.08.708h-.033a1.175,1.175,0,0,0-.989.538,1.174,1.174,0,0,0-.088,1.121l.01.021a1.154,1.154,0,0,1-.083,1.116,1.175,1.175,0,0,1-.984.544,1.185,1.185,0,0,1-.4-.07h-.005a1.181,1.181,0,0,0-.395-.068,1.184,1.184,0,0,0-.87.387,1.161,1.161,0,0,0-.3.9v.013a1.157,1.157,0,0,1-.3.9,1.2,1.2,0,0,1-.883.392,1.159,1.159,0,0,1-.727-.259,1.164,1.164,0,0,0-.729-.256,1.181,1.181,0,0,0-1.15.9v0A1.168,1.168,0,0,1-4229.021-6663.778Zm-7.2-15.261a.709.709,0,0,0-.522.232l-1.041,1.122a.835.835,0,0,0,0,1.12l4.787,5.15a.712.712,0,0,0,.522.231.71.71,0,0,0,.52-.231l8.471-9.111a.84.84,0,0,0,0-1.122l-1.041-1.12a.711.711,0,0,0-.522-.232.705.705,0,0,0-.521.232l-6.908,7.43-3.226-3.469A.706.706,0,0,0-4236.221-6679.039Z"
                            transform="translate(4244.209 6690.181)"
                          />
                        </svg>
                      </span>
                    </h2>
                    <span className="designation">{item.userdataathletesportsmaprel.Athletesports ? item.userdataathletesportsmaprel.Athletesports[0].sportname : ""}</span>
                    <p className="info">
                      Washington High School • San Diego, CA Club Team: Delhi
                      Dragons 17U Team
                </p>
                    <p className="email">619.953.0000 - {item.athleteemail}</p>
                    {item.onBoardingUserIdMap.Onboardings.length != 0 && item.onBoardingUserIdMap.Onboardings[0].twitteraccountname ?
                      <p className="social">
                        <span className="icon">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="32.544"
                            height="26.437"
                            viewBox="0 0 32.544 26.437"
                          >
                            <defs>
                              <style></style>
                            </defs>
                            <path
                              className="a"
                              d="M32.544,3.131a13.52,13.52,0,0,1-3.336,3.448q.02.382.02.864a19.178,19.178,0,0,1-3.166,10.5A20.284,20.284,0,0,1,22.24,22.29a17.038,17.038,0,0,1-5.332,3.02,19.474,19.474,0,0,1-6.674,1.126A18.584,18.584,0,0,1,0,23.436a14.437,14.437,0,0,0,1.593.092,13.09,13.09,0,0,0,8.293-2.86,6.478,6.478,0,0,1-3.877-1.332,6.562,6.562,0,0,1-2.357-3.3,6.674,6.674,0,0,0,3.015-.112,6.507,6.507,0,0,1-3.833-2.3A6.46,6.46,0,0,1,1.312,9.376V9.294a6.589,6.589,0,0,0,3.025.835A6.632,6.632,0,0,1,2.167,7.75a6.515,6.515,0,0,1-.8-3.175,6.56,6.56,0,0,1,.9-3.355A19.01,19.01,0,0,0,8.355,6.148,18.553,18.553,0,0,0,16.027,8.2a6.529,6.529,0,0,1-.175-1.52,6.432,6.432,0,0,1,1.956-4.72,6.679,6.679,0,0,1,9.594.149A13.3,13.3,0,0,0,31.641.485,6.455,6.455,0,0,1,28.708,4.18a13.343,13.343,0,0,0,3.836-1.049Z"
                            />
                          </svg>
                        </span>
                        <span>{item.onBoardingUserIdMap.Onboardings[0].twitteraccountname}</span>
                      </p> : ""}
                    <ul>
                      <li className="likes">
                        <span className="icon">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="21.089"
                            height="15.981"
                            viewBox="0 0 21.089 15.981"
                          >
                            <defs>
                              <style></style>
                            </defs>
                            <g transform="translate(-364.759 -164)">
                              <g transform="translate(364.759 101.997)">
                                <g transform="translate(8.98 68.387)">
                                  <g transform="translate(0 0)">
                                    <circle
                                      className="a"
                                      cx="1.606"
                                      cy="1.606"
                                      r="1.606"
                                    />
                                  </g>
                                </g>
                                <g transform="translate(5.89 65.298)">
                                  <g transform="translate(0 0)">
                                    <path
                                      className="a"
                                      d="M147.709,142a4.7,4.7,0,1,0,4.7,4.7A4.7,4.7,0,0,0,147.709,142Zm0,7.743a3.048,3.048,0,1,1,3.048-3.048A3.051,3.051,0,0,1,147.709,149.745Z"
                                      transform="translate(-143.014 -142.002)"
                                    />
                                  </g>
                                </g>
                                <g transform="translate(0 62.003)">
                                  <g transform="translate(0 0)">
                                    <path
                                      className="a"
                                      d="M20.555,68.2a15.923,15.923,0,0,0-3.68-3.9A10.48,10.48,0,0,0,10.563,62a10.534,10.534,0,0,0-6.318,2.288,16.038,16.038,0,0,0-3.7,3.893,3.29,3.29,0,0,0,0,3.619,16.037,16.037,0,0,0,3.7,3.893,10.534,10.534,0,0,0,6.318,2.288,11.425,11.425,0,0,0,7.618-3.392.824.824,0,1,0-1.127-1.2,9.824,9.824,0,0,1-6.491,2.946c-4,0-7.315-3.419-8.644-5.439a1.644,1.644,0,0,1,0-1.808c1.329-2.02,4.645-5.439,8.644-5.439s7.3,3.422,8.612,5.444a1.648,1.648,0,0,1,0,1.8.824.824,0,0,0,1.381.9A3.3,3.3,0,0,0,20.555,68.2Z"
                                      transform="translate(0 -62.003)"
                                    />
                                  </g>
                                </g>
                              </g>
                            </g>
                          </svg>
                        </span>
                        <span>2.1k</span>
                      </li>
                      <li className="follower">
                        <span>18 </span>
                        <span className="label">followers</span>
                      </li>
                      <li className="following">
                        <span>32 </span>
                        <span className="label">following</span>
                      </li>
                    </ul>
                  </div>
              <div className="infoBoxFlex">
                <div className="item">
                  <span className="label">Grad Year</span>
                  <span>{item.userdataathletegraduationyearmaprel.Graduationyears ? item.userdataathletegraduationyearmaprel.Graduationyears[0].yearvalue : ""}</span>
                </div>
                <div className="item">
                  <span className="label">Position</span>
                  <span>RHP / 3B</span>
                </div>
                <div className="item">
                  <span className="label">Height / Weight</span>
                  <span>6'1" / 165</span>
                </div>
                <div className="item commmitBox">
                  <span className="label">Committed</span>
                  <span className="imgBox">
                    <img src={TrojansLogo} alt="" />
                  </span>
                  <span>USC</span>
                </div>
                <div className="item">
                  <span className="label">Bat / Throw</span>
                  <span>R / R</span>
                </div>
                <div className="item gpaScore">
                  <span className="label">GPA / Score</span>
                  <span className="lockIcon">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="13.286"
                      height="15.5"
                      viewBox="0 0 13.286 15.5"
                    >
                      <defs>
                        <style></style>
                      </defs>
                      <g transform="translate(-4.5 -2.25)">
                        <path
                          className="a"
                          d="M15.571,8.893a2.214,2.214,0,0,1,2.214,2.214v4.429a2.214,2.214,0,0,1-2.214,2.214H6.714A2.214,2.214,0,0,1,4.5,15.536V11.107A2.214,2.214,0,0,1,6.714,8.893V6.679a4.429,4.429,0,1,1,8.857,0ZM11.143,3.726A2.952,2.952,0,0,1,14.1,6.679V8.893H8.19V6.679a2.952,2.952,0,0,1,2.952-2.952Zm4.429,6.643H6.714a.738.738,0,0,0-.738.738v4.429a.738.738,0,0,0,.738.738h8.857a.738.738,0,0,0,.738-.738V11.107A.738.738,0,0,0,15.571,10.369Z"
                        />
                      </g>
                    </svg>
                  </span>
                  <span className="infoIcon">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="17.999"
                      height="17.999"
                      viewBox="0 0 17.999 17.999"
                    >
                      <defs>
                        <style></style>
                      </defs>
                      <path
                        className="a"
                        d="M10.445,7.271a.846.846,0,0,1,.844-.844h.562a.846.846,0,0,1,.844.844v.562a.846.846,0,0,1-.844.844h-.562a.846.846,0,0,1-.844-.844Zm3.375,8.156H9.32V14.3h1.125V10.927H9.32V9.8h3.375v4.5H13.82Zm-2.25-13.5a9,9,0,1,0,9,9,9,9,0,0,0-9-9Zm0,16.311a7.312,7.312,0,1,1,7.312-7.312A7.312,7.312,0,0,1,11.57,18.239Z"
                        transform="translate(-2.571 -1.928)"
                      />
                    </svg>
                  </span>
                </div>
                <div className="item satAct">
                  <span className="label">SAT/ACT</span>
                  <span>32 / 1320</span>
                </div>
                <div className="item rating">
                  <span className="label">Rating</span>
                  <span className="lockIcon">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="13.286"
                      height="15.5"
                      viewBox="0 0 13.286 15.5"
                    >
                      <defs>
                        <style></style>
                      </defs>
                      <g transform="translate(-4.5 -2.25)">
                        <path
                          className="a"
                          d="M15.571,8.893a2.214,2.214,0,0,1,2.214,2.214v4.429a2.214,2.214,0,0,1-2.214,2.214H6.714A2.214,2.214,0,0,1,4.5,15.536V11.107A2.214,2.214,0,0,1,6.714,8.893V6.679a4.429,4.429,0,1,1,8.857,0ZM11.143,3.726A2.952,2.952,0,0,1,14.1,6.679V8.893H8.19V6.679a2.952,2.952,0,0,1,2.952-2.952Zm4.429,6.643H6.714a.738.738,0,0,0-.738.738v4.429a.738.738,0,0,0,.738.738h8.857a.738.738,0,0,0,.738-.738V11.107A.738.738,0,0,0,15.571,10.369Z"
                        />
                      </g>
                    </svg>
                  </span>
                  <span className="infoIcon">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="17.999"
                      height="17.999"
                      viewBox="0 0 17.999 17.999"
                    >
                      <defs>
                        <style></style>
                      </defs>
                      <path
                        className="a"
                        d="M10.445,7.271a.846.846,0,0,1,.844-.844h.562a.846.846,0,0,1,.844.844v.562a.846.846,0,0,1-.844.844h-.562a.846.846,0,0,1-.844-.844Zm3.375,8.156H9.32V14.3h1.125V10.927H9.32V9.8h3.375v4.5H13.82Zm-2.25-13.5a9,9,0,1,0,9,9,9,9,0,0,0-9-9Zm0,16.311a7.312,7.312,0,1,1,7.312-7.312A7.312,7.312,0,0,1,11.57,18.239Z"
                        transform="translate(-2.571 -1.928)"
                      />
                    </svg>
                  </span>
                </div>
                <div className="showhideBox">
                  <a href="#">
                    <span className="icon">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="8"
                        height="4"
                        viewBox="0 0 8 4"
                      >
                        <defs>
                          <style></style>
                        </defs>
                        <path
                          className="a"
                          d="M4,0,8,4H0Z"
                          transform="translate(8 4) rotate(180)"
                        ></path>
                      </svg>
                    </span>
                  </a>
                </div>
              </div>
              </>):""}
              <div className="actionBox">
                <button className="followBtn">
                  <span className="icon">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="23.66"
                      height="18"
                      viewBox="0 0 23.66 18"
                    >
                      <defs>
                        <style></style>
                      </defs>
                      <path
                        className="a"
                        d="M329.452,3.546h-3.019V.662a.694.694,0,0,0-1.386,0V3.546h-3.019a.663.663,0,1,0,0,1.324h3.019V7.755a.694.694,0,0,0,1.386,0V4.871h3.019a.663.663,0,1,0,0-1.324Z"
                        transform="translate(-306.485)"
                      />
                      <path
                        className="a"
                        d="M8.118,321.334A7.952,7.952,0,0,0,0,329.089a.678.678,0,0,0,.693.662H15.542a.678.678,0,0,0,.693-.662A7.952,7.952,0,0,0,8.118,321.334Z"
                        transform="translate(0 -311.751)"
                      />
                      <path
                        className="a"
                        d="M84.739,64.267a4.213,4.213,0,1,0,4.405,4.209A4.315,4.315,0,0,0,84.739,64.267Z"
                        transform="translate(-76.622 -64.267)"
                      />
                    </svg>
                  </span>
                  <span>Follow</span>
                </button>
                <button className="promoteBtn">
                  <span className="icon">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="23.973"
                      height="19"
                      viewBox="0 0 23.973 19"
                    >
                      <defs>
                        <style></style>
                      </defs>
                      <g transform="translate(0 0)">
                        <path
                          className="a"
                          d="M0,7.74a2.152,2.152,0,0,0,1.4,2.04V5.9c0-.056.028-.14.028-.2A2.179,2.179,0,0,0,0,7.74Z"
                          transform="translate(0 0.196)"
                        />
                        <path
                          className="a"
                          d="M6.358,10.355H2.7l1.369,4.973a1.732,1.732,0,0,0,1.676,1.285,1.76,1.76,0,0,0,1.425-.7,1.62,1.62,0,0,0,.279-1.509Z"
                          transform="translate(1.27 2.386)"
                        />
                        <path
                          className="a"
                          d="M.969,5.69H1V5.662C1,5.69,1,5.69.969,5.69Z"
                          transform="translate(0.456 0.178)"
                        />
                        <path
                          className="a"
                          d="M14.663,5.415H14.44v5.029h.224a2.515,2.515,0,0,0,0-5.029Z"
                          transform="translate(6.795 0.062)"
                        />
                        <path
                          className="a"
                          d="M1.52,6.387v3.968A1.9,1.9,0,0,0,3.42,12.2H8.505V4.655H3.42A1.817,1.817,0,0,0,1.52,6.387Z"
                          transform="translate(0.715 -0.296)"
                        />
                        <path
                          className="a"
                          d="M6.84,13.706l10.338,4.135V1.691L6.84,5.826Z"
                          transform="translate(3.219 -1.691)"
                        />
                      </g>
                    </svg>
                  </span>
                  <span>Promote</span>
                </button>
                <button
                  className={`menuBtn ${expand ? "" : "show"}`}
                  onClick={() => handleCollapseExpand()}
                  id="dropdownMenuButton"
                  data-toggle="dropdown"
                  aria-haspopup="true"
                  aria-expanded="false"
                >
                  <span className="icon">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="4.36"
                      height="21.801"
                      viewBox="0 0 4.36 21.801"
                    >
                      <defs>
                        <style></style>
                      </defs>
                      <g transform="translate(175.026) rotate(90)">
                        <g transform="translate(0 170.666)">
                          <g transform="translate(0 0)">
                            <circle
                              className="a"
                              cx="2.18"
                              cy="2.18"
                              r="2.18"
                            />
                          </g>
                        </g>
                        <g transform="translate(8.721 170.666)">
                          <g transform="translate(0 0)">
                            <circle
                              className="a"
                              cx="2.18"
                              cy="2.18"
                              r="2.18"
                            />
                          </g>
                        </g>
                        <g transform="translate(17.441 170.666)">
                          <g transform="translate(0 0)">
                            <circle
                              className="a"
                              cx="2.18"
                              cy="2.18"
                              r="2.18"
                            />
                          </g>
                        </g>
                      </g>
                    </svg>
                  </span>
                </button>
                <div
                  className={`dropdown-menu ${expand ? "show" : ""}`}
                  aria-labelledby="dropdownMenuButton"
                >
                  <a className="dropdown-item" href="#">
                    <span className="icon">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="14"
                        height="15.458"
                        viewBox="0 0 14 15.458"
                      >
                        <defs>
                          <style></style>
                        </defs>
                        <path
                          className="a"
                          d="M16.16,14.047a2.125,2.125,0,0,0-1.521.583L9.063,11.406a2.612,2.612,0,0,0,.078-.544,2.61,2.61,0,0,0-.078-.544l5.5-3.185a2.334,2.334,0,1,0-.741-1.709,2.6,2.6,0,0,0,.078.544L8.4,9.153a2.347,2.347,0,0,0-1.6-.621,2.309,2.309,0,0,0-2.3,2.33,2.348,2.348,0,0,0,3.939,1.709l5.538,3.224a1.948,1.948,0,0,0-.078.5,2.262,2.262,0,1,0,2.262-2.253Z"
                          transform="translate(-4.5 -3.094)"
                        />
                      </svg>
                    </span>
                    <span>Share</span>
                  </a>
                  <a className="dropdown-item" href="#">
                    <span className="icon">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="14"
                        height="12.194"
                        viewBox="0 0 14 12.194"
                      >
                        <defs>
                          <style></style>
                        </defs>
                        <path
                          className="a"
                          d="M15,11.1a.226.226,0,0,1-.136.207L1.315,17.174a.226.226,0,0,1-.285-.32l2.662-4.615a.226.226,0,0,1,.113-.1L6.477,11.1,3.805,10.051a.226.226,0,0,1-.113-.1L1.03,5.338a.226.226,0,0,1,.285-.32l13.548,5.871A.226.226,0,0,1,15,11.1Z"
                          transform="translate(-0.999 -4.999)"
                        />
                      </svg>
                    </span>
                    <span>Send message</span>
                  </a>
                </div>
              </div>


              <div className="metricCarouselBox">
                <h5 className="title">Metrics</h5>
                <div className="metricCarousel owl-carousel  owl-theme"></div>
                <FollowMetricsCarousel />
              </div>
            </div>
          </div>
        </div>

        <div className="bottomSection">
          <div className="container">
            <div>
              <div className="tabBox">
                <nav>
                  <ul>
                    <li className="closeBtnBox">
                      <button className="closeBtn">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="15.804"
                          height="15.803"
                          viewBox="0 0 15.804 15.803"
                        >
                          <defs>
                            <style></style>
                          </defs>
                          <g className="a" transform="translate(-6.776 -6.776)">
                            <path
                              d="M8.579,7.086A1.056,1.056,0,1,0,7.086,8.579l6.1,6.1-6.1,6.1A1.056,1.056,0,1,0,8.578,22.27l6.1-6.1,6.1,6.1a1.056,1.056,0,1,0,1.493-1.493l-6.1-6.1,6.1-6.1a1.056,1.056,0,1,0-1.493-1.493l-6.1,6.1-6.1-6.1Z"
                              transform="translate(0 0)"
                            />
                          </g>
                        </svg>
                      </button>
                    </li>
                    <li className="selected">
                      <a href="">Timeline</a>
                    </li>
                    <li>
                      <a href="">Videos & Photos</a>
                    </li>
                    <li>
                      <a href="">About</a>
                    </li>
                    <li>
                      <a href="">Stats</a>
                    </li>
                    <li>
                      <a href="">Reports</a>
                    </li>
                  </ul>
                </nav>
                <div className="flexBox">
                  <div className="menuBtnBox">
                    <button className="tabMenuBtn">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="12"
                        viewBox="0 0 16 12"
                      >
                        <defs>
                          <style></style>
                        </defs>
                        <g transform="translate(-284.664 -20.498)">
                          <rect
                            className="a"
                            width="16"
                            height="2"
                            rx="1"
                            transform="translate(284.664 20.498)"
                          />
                          <rect
                            className="a"
                            width="16"
                            height="2"
                            rx="1"
                            transform="translate(284.664 25.498)"
                          />
                          <rect
                            className="a"
                            width="16"
                            height="2"
                            rx="1"
                            transform="translate(284.664 30.498)"
                          />
                        </g>
                      </svg>
                    </button>
                  </div>
                  <div>
                    <p>Timeline</p>
                  </div>
                </div>
              </div>
              <div className="TimelineData">
                <Timeline />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    
  );
};

const mapStateToProps = (state) => {
  return {
    userDetails: state.auth.previewProfile
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    previewProfileStart: (data) => dispatch(previewProfileStart(data))
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(FollowDarkProfile);

